<div *ngIf="event?.closed" class="closed_msg">
  Closed events can't be published.<br /><br />
  Any shareable URLs for this event have been unpublished.
</div>

<ng-template #publishedInfo>
  <div class="publish-info-holder" [ngClass]="{ preview: openPage === 'PREVIEW' }">
    <div class="publish-success" *ngIf="showSuccess">Success!</div>
    <div *ngIf="publishInfo.status !== 'never published'" class="publish-info">
      {{ publishInfo.status === 'published' ? 'Last updated' : 'Unpublished' }} by {{ publishInfo.publisher }} at {{ publishInfo.publishedAt | date: 'h:mmaaaaa\'m\' on d MMMM yyyy' }}.
    </div>
  </div>
</ng-template>
<ng-template #bigAndLittle let-title="title" let-message="message">
  <div class="not-published-notice">
    <div class="title">{{ title }}</div>
    <div class="content">{{ message }}</div>
  </div>
</ng-template>

<joi-nav-wrapper *ngIf="event && !event.closed" [menuItems]="subPages" [selectedId]="openPage" [hiddenMobileItems]="hiddenMobileSubpages" (selectItem)="openPage = $event">
  <traffic-light [color]="statusToColor[publishInfo.status]" [text]="statusToText[publishInfo.status]"></traffic-light>
  <div class="unpublish-link" *ngIf="publishInfo.status === 'published' && event.can_access" (click)="confirmPublishAction(false)">Unpublish</div>
</joi-nav-wrapper>

<ng-container *ngIf="!event?.closed && openPage === 'DESIGN'">
  <scrollable-wrapper class="builder" *ngIf="!event?.closed && !!publishInfo">
    <publish-builder [publishInfo]="publishInfo"></publish-builder>
  </scrollable-wrapper>
  
</ng-container>

<ng-container *ngIf="!event?.closed && openPage === 'CONFIGURE'">
  <div class="top_container">
    <div class="publish_menu" *ngIf="!event?.is_readonly">
      <div class="unpublished-notice">
        Use Display Options and Filter timeline to configure the information showing on these pages
      </div>
      <div style="flex:1;" class="disappearing-spacer" ></div>
      <icon-text [text]="'Name & description'" [icon]="'edit'" (click)="editNameAndDescription()"></icon-text>
      <icon-text [text]="'CTA Links'" [icon]="'call_to_action'" (click)="editCallToActionLinks()"></icon-text>
      <icon-text [text]="'Display options'" [icon]="'CHECKBOX_FULL'"  (click)="editFields()"></icon-text>
      <icon-text [active]="!!publishInfo?.filters?.count" [text]="'Filter timeline'" (click)="openFilters()"></icon-text>
    </div>
  </div>
  <scrollable-wrapper *ngIf="!event?.closed && !!publishInfo">
    <publish-timeline 
      *ngIf="!hideTimeline"
      [title]="publishInfo.excludedFieldIds.includes('publishedName') ? null : publishInfo.title" 
      [madeWithJoi]="previewMadeWithJoi" 
      [joiEvent]="eventDataPreview?.eventInfo" 
      [brandingData]="eventDataPreview?.brandingData"
      [homePageData]="eventDataPreview?.homePageData"
      [data]="eventDataPreview?.timeline" 
      [CTALinks]="publishInfo.CTALinks"
      [version]="eventDataPreview?.internalVersion"
      [venue]="previewVenue"
      [loading]="loadingPreview"
      [tabNames]="tabNames"
      [excludedFieldIds]="publishInfo.excludedFieldIds"
      [isConfigure]="true"
      (change)="change($event)"
    ><div class="configure-home">
      <branding-text 
        [title]="'Header copy'"
        [brandingText]="publishInfo.homePageData.headerText"
        (changed)="savePublishInfo()"
      ></branding-text>
      <branding-block
        *ngIf="{ count: (publishInfo.CTALinks || []).length } as cta"
        [title]="'Call to Action Buttons'"
        [icon]="'call_to_action'"
        [hideGreyText]="true"
        [greyText]="!cta.count ? 'NO CTAs' : (cta.count + ' CTA' + ( cta.count > 0 ? 's' : '') + ' ADDED')"
        [changeText]="'+ ADD CTA LINK BUTTONS'"
        (change)="editCallToActionLinks()"
      >
        <calls-to-action *ngIf="!!cta.count" [ctas]="publishInfo.CTALinks"
          [style.--primary]="brandingData?.template.primary"
          [style.--primaryhover]="brandingData?.template.primaryhover"
        ></calls-to-action>
      </branding-block>
      <branding-text 
        [title]="'Body copy'"
        [brandingText]="publishInfo.homePageData.bodyText"
        (changed)="savePublishInfo()"
      ></branding-text>
      <ng-container *ngIf="(publishInfo.homePageData?.performerIds || []) | idsToItems:performers as performerList">
        <branding-block
          id="performer-block"
          *ngIf="{ count: performerList.length } as p"
          [title]="'Performers'"
          [icon]="'performers24'"
          [hideGreyText]="true"
          [greyText]="!p.count ? 'NO PERFORMERS ADDED' : (p.count + ' PERFORMER' + ( p.count > 0 ? 's' : '') + ' ADDED')"
          [changeText]="!p.count ? '+ ADD PERFORMERS' : '+ MODIFY PERFORMERS'"
          (change)="selectEntities('performer')"
        ><performer-gallery *ngIf="!!p.count" [performerList]="performerList" ></performer-gallery>
        </branding-block>
      </ng-container>

      <ng-container *ngIf="(publishInfo.homePageData?.sponsorIds || []) | idsToItems:sponsors as sponsorList">
        <branding-block
          id="sponsor-block"
          *ngIf="{ count: sponsorList.length } as s"
          [title]="'Sponsors'"
          [icon]="'sponsor24'"
          [hideGreyText]="true"
          [greyText]="!s.count ? 'NO SPONSORS ADDED' : (s.count + ' SPONSOR' + ( s.count > 0 ? 's' : '') + ' ADDED')"
          [changeText]="!s.count ? '+ ADD SPONSORS' : '+ MODIFY SPONSORS'"
          (change)="selectEntities('sponsor')"
        ><div class="sponsors-holder" *ngIf="!!s.count">
          <sponsor-gallery-card *ngFor="let sponsor of sponsorList" [sponsor]="sponsor"></sponsor-gallery-card>
        </div>
        </branding-block>
      </ng-container>

      <ng-container *ngIf="(publishInfo.homePageData?.exhibitorIds || []) | idsToItems:exhibitors as exhibitorList">
        <branding-block
          id="exhibitor-block"
          *ngIf="{ count: exhibitorList.length } as e"
          [title]="'Exhibitors'"
          [icon]="'exhibitors_24'"
          [hideGreyText]="true"
          [greyText]="!e.count ? 'NO EXHIBITORS ADDED' : (e.count + ' EXHIBITOR' + ( e.count > 0 ? 's' : '') + ' ADDED')"
          [changeText]="!e.count ? '+ ADD EXHIBITORS' : '+ MODIFY EXHIBITORS'"
          (change)="selectEntities('exhibitor')"
        ><div class="sponsors-holder" *ngIf="!!e.count">
          <sponsor-gallery-card *ngFor="let exhibitor of exhibitorList" [showName]="true" [sponsor]="exhibitor"></sponsor-gallery-card>
        </div>
        </branding-block>
      </ng-container>

      <branding-text 
        [title]="'Text block'"
        [brandingText]="publishInfo.homePageData.textBlock"
        (changed)="savePublishInfo()"
      ></branding-text>

      <branding-block
        id="slider-block"
        *ngIf="{ count: publishInfo.homePageData?.sliderImages?.length || 0 } as s"
        [title]="'Slider Images'"
        [icon]="'scenic'"
        [hideGreyText]="true"
        [greyText]="!s.count ? 'NO SLIDER IMAGES ADDED' : (s.count + ' SLIDER IMAGE' + ( s.count > 0 ? 's' : '') + ' ADDED')"
        [changeText]="'+ ADD SLIDER IMAGE'"
        (change)="editSliderImage(null)"
      ><div class="slider-images-holder">
        <div class="slider-image" *ngFor="let image of (publishInfo?.homePageData?.sliderImages || []); index as i;">
          <slider-image [sliderImage]="image"></slider-image>
          <div class="image-hover" (click)="editSliderImage(i)">
            <icon [icon]="'camera'"></icon>
          </div>
        </div>
      </div>
      </branding-block>
    </div>
    
    </publish-timeline>
  </scrollable-wrapper>
</ng-container>

<ng-container *ngIf="!event?.closed && openPage === 'PREVIEW'">
  <div class="top_container">
    <div class="publish_menu" *ngIf="!event?.is_readonly">
      <div class="unpublished-notice">
        Below is a preview of the sharable webpage after you publish.
      </div>
      <div style="flex:1;" class="disappearing-spacer" ></div>
      <ng-container [ngTemplateOutlet]="publishedInfo"></ng-container>
      <button mat-button color="primary" [disabled]="processing" (click)="confirmPublishAction(true)">
        <div class="button_content">
          {{ publishInfo.status !== 'published' ? 'Publish' : 'Update' }}
          <loader icon="button_wheel"></loader>
        </div>
      </button>
    </div>
  </div>
  <scrollable-wrapper *ngIf="!event?.closed && !!publishInfo">
    <publish-timeline 
      *ngIf="!hideTimeline"
      [title]="publishInfo.excludedFieldIds.includes('publishedName') ? null : publishInfo.title" 
      [madeWithJoi]="previewMadeWithJoi" 
      [joiEvent]="eventDataPreview?.eventInfo" 
      [brandingData]="eventDataPreview?.brandingData"
      [homePageData]="eventDataPreview?.homePageData"
      [data]="eventDataPreview?.timeline" 
      [CTALinks]="publishInfo.CTALinks"
      [version]="eventDataPreview?.internalVersion"
      [venue]="previewVenue"
      [loading]="loadingPreview"
      [tabNames]="tabNames"
      [excludedFieldIds]="publishInfo.excludedFieldIds"
      [isPreview]="true"
    ></publish-timeline>
  </scrollable-wrapper>
</ng-container>

<ng-container *ngIf="!event?.closed && openPage === 'PUBLISHED'">
  <div class="top_container">
    <ng-container *ngIf="publishInfo.status === 'never published'
    " [ngTemplateOutlet]="bigAndLittle" [ngTemplateOutletContext]="{title: 'Nothing here!', message: 'Looks like you haven\’t published anything yet. Head back over to the Preview tab to publish your page.'}"></ng-container>
    <share-code 
      *ngIf="publishInfo.status !== 'never published'" 
      [shareCode]="publishInfo.publishCode"
      [openText]="'Open in a new tab'"
      [shareType]="shareTypes.publish"
      [showEmbed]="true"
      [disabled]="publishInfo.status !== 'published'"
      [emailGenerator]="emailGenerator.bind(this)"
    ></share-code>
    <ng-container [ngTemplateOutlet]="publishedInfo"></ng-container>
    <div class="publish_message" *ngIf="publishInfo.status !== 'never published'">
      Below is what’s currently published to your shareable webpage.
    </div>
  </div>
  <scrollable-wrapper *ngIf="!event?.closed && publishInfo && publishInfo.status !== 'never published'">
    <ng-container *ngIf="publishInfo.status === 'unpublished'" [ngTemplateOutlet]="bigAndLittle" [ngTemplateOutletContext]="{title: 'Sorry!', message: 'This page is currently unavailable.'}"></ng-container>
    <publish-timeline 
      *ngIf="publishInfo.status === 'published'" 
      [madeWithJoi]="publishedMadeWithJoi" 
      [joiEvent]="eventData?.eventInfo" 
      [data]="eventData?.timeline" 
      [CTALinks]="eventData?.CTALinks"
      [venue]="eventData?.venue"
      [version]="eventData?.internalVersion"
      [loading]="loadingPublished" 
      [brandingData]="eventData?.brandingData"
      [homePageData]="eventData?.homePageData"
      [tabNames]="eventData?.tabNames || tabNames"
      [title]="eventData?.excludedFieldIds.includes('publishedName') ? null : eventData?.eventInfo?.title"
      [excludedFieldIds]="eventData?.excludedFieldIds"
    ></publish-timeline>
  </scrollable-wrapper>
</ng-container>

  